import { Header } from '../../../../../components/DataTable'

export const headers: Header[] = [
  { name: 'Indicador', field: 'indicator.name', sortable: true },
  { name: 'Nome', field: 'name', sortable: true },
  { name: 'Email', field: 'email', sortable: true },
  { name: 'Celular', field: 'phone', sortable: true, custom: true },
  { name: 'País de destino', field: 'serviceCountry.name', sortable: true },
  { name: 'Candidatos', field: 'applicants_quantity', sortable: true },
  {
    name: 'Ações',
    field: 'actions',
    sortable: false
  }
]
